import globalSlice from "./slices/globalSlice";
import userSlice from "./slices/userSlice";
import roleSlice from "./slices/roleSlice";
import dashboardSlice from "./slices/dashboardSlice";
import dashboard360Slice from "./slices/dashboard360Slice";
import { combineReducers } from "@reduxjs/toolkit";
import customFieldSlice from "./slices/customFieldSlice";
import teamSlice from "./slices/teamSlice";
import customerSlice from "./slices/customerSlice";
import dealAndPipelineSlice from "./slices/dealAndPipelineSlice";
import expenseSlice from "./slices/expenseSlice";
import orderSlice from "./slices/orderSlice";
import saleOrderSlice from "./slices/saleOrderSlice";
import secondarySalesOrderSlice from "./slices/SecondarySalesOrderSlice";
import layoutConfigSlice from "./slices/layoutConfigSlice";
import salesInvoiceSlice from "./slices/salesInvoiceSlice";
import distributorInventorySlice from "./slices/distributorInventorySlice";
import AttendanceSettingSlice from "./slices/attendanceSettingSlice";
import categoriesMasterSlice from "./slices/categoryMasterSlice";
import expenseSettingSlice from "./slices/expenseSettingSlice";
import productMasterSlice from "./slices/productMasterSlice";
import rosterPlanSlice from "./slices/rosterPlanSlice";
import assetManagementSlice from "./slices/assetManagementSlice";
import crmSettingSlice from "./slices/crmSettingSlice";
import CrmConfigurationSlice from "./slices/crmConfigurationSlice";
import taskSettingSlice from "./slices/taskSettingSlice";
import expenseByTeamSlice from "./slices/expenseByTeamSlice";
import vistFormSlice from "./slices/visitFormSlice";
import salesReportSlice from "./slices/SalesReportSlice";
import userSeparationSlice from "./slices/UserSeparationSlice";
import leaveSlice from "./slices/leaveSlice";
import leaveRequestsSlice from "./slices/leaveRequestsSlice";
import territorySlice from "./slices/territorySlice";
import customerReportSlice from "./slices/customerReportSlice";
import taskSlice from "./slices/myTaskSlice";
import OrganizationalUnitSlice from "./slices/organizationalUnitSlice";
import scheduleReportsSlice from "./slices/ScheduleReportsSlice";
import workingHoursSlice from "./slices/workingHoursSlice";
import opportunityReportSlice from "./slices/opportunityReportSlice";
import attendanceCoverageReportSlice from "./slices/attendanceCoverageReportSlice";
import CompanySettingSlice from "./slices/CompanySetingSlice";
import customTemplateSlice from "./slices/customTemplateSlice";
import ReferralProgramSlice from "./slices/ReferralProgramSlice";
import attendenaceLogsReportSlice from "./slices/AttendenaceLogsReportSlice";
import  geofenceManagementSlice from "./slices/GeofenceManagementSlice";
import locationCoverageReportSlice from "./slices/locationCoverageReportSlice";
import opportunityConfigurationSlice from "./slices/opportunityConfigurationSlice";
import leadCaptureSlice from "./slices/leadCaptureSlice";
import userReportSlice from "./slices/userReportSlice";
import exportReportSettingSlice from "./slices/exportReportSettingSlice";

const rootReducer: any = combineReducers({
  global: globalSlice,
  user: userSlice,
  role: roleSlice,
  dashboard: dashboardSlice,
  dashboard360: dashboard360Slice,
  customField: customFieldSlice,
  team: teamSlice,
  customer: customerSlice,
  deal: dealAndPipelineSlice,
  orders: orderSlice,
  saleOrder: saleOrderSlice,
  expense: expenseSlice,
  secondarySaleOrder: secondarySalesOrderSlice,
  layoutConfig: layoutConfigSlice,
  saleInvoice: salesInvoiceSlice,
  inventory: distributorInventorySlice,
  attendanceSetting: AttendanceSettingSlice,
  expenseSetting: expenseSettingSlice,
  categoryMaster: categoriesMasterSlice,
  productMaster: productMasterSlice,
  rosterPlan: rosterPlanSlice,
  asset: assetManagementSlice,
  crmSetting: crmSettingSlice,
  crmConfiguration: CrmConfigurationSlice,
  taskSetting: taskSettingSlice,
  expenseByTeam: expenseByTeamSlice,
  visitForm: vistFormSlice,
  salesReport: salesReportSlice,
  userSeparation: userSeparationSlice,
  leave: leaveSlice,
  leaveRequests: leaveRequestsSlice,
  territory: territorySlice,
  organizationalUnit: OrganizationalUnitSlice,
  schedule: scheduleReportsSlice,
  workingHours: workingHoursSlice,
  customerReport: customerReportSlice,
  opportunityReport: opportunityReportSlice,
  task: taskSlice,
  attendanceCoverageReport: attendanceCoverageReportSlice,
  companySetting: CompanySettingSlice,
  customTemplate: customTemplateSlice,
  referrals :ReferralProgramSlice ,
  attendenaceLogsReport: attendenaceLogsReportSlice,
  usergeofenceManagement : geofenceManagementSlice, 
  locationCoverageReport: locationCoverageReportSlice,
  opportunityConfiguration: opportunityConfigurationSlice,
  lead: leadCaptureSlice,
  userReport: userReportSlice,
  exportReport: exportReportSettingSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
